import {useQuery} from "react-query";
import axios from "axios";
import {PagedSearchParams} from "@atiautomacao/ati-ui-library";

interface PowerStationTree {
    id: number;
    name: string;
    selected?: any;
    status?: any;
    skidList: {
        id: number;
        name: string;
        selected?: boolean;
        status?: any;
        equipmentList: {
            id: number,
            name: string,
            selected?: any;
            etsStatus?: string;
        }[]
    }[];
    equipmentList: {
        id: number,
        name: string,
        selected?: any;
        etsStatus?: any;
    }[]
}

interface Response {
    message: string;
    data: Array<PowerStationTree>
}

const apiUrl = "api/equipment";
const apiPowerStationTreeUrl = 'api/power-station/selection-tree';

const fetchTeleCommands = async (equipmentIds: number[], pagedSearchParams: PagedSearchParams) => {

    try {
        const queryParams = new URLSearchParams();
        if (equipmentIds && equipmentIds.length > 0) {
            queryParams.append('equipmentIds', equipmentIds.join(','));
        }

        if (pagedSearchParams) {
            const extraParams = pagedSearchParams.toURLSearchParams();
            extraParams.forEach((value, key) => queryParams.append(key, value));
        }

        const newApiUrl = `${apiUrl}/tele-commands?${queryParams.toString()}`;

        const response = await axios.get(newApiUrl);
        return response.data;
    } catch (error: any) {
        console.error("Error fetching data:", error);
        throw new Error("Error fetching data: " + error.message);
    }
};

const fetchPowerStationTree = async (): Promise<Response> =>{
    return await axios
        .get<Response>(`${apiPowerStationTreeUrl}`,{timeout:30000})
        .then((res) => res.data)
}

export const TeleCommandReactQuery = (equipmentIds: number[], pagedSearchParams: PagedSearchParams) => {
    return useQuery({
        queryKey: ["data", pagedSearchParams, equipmentIds],
        queryFn: () => {
            return fetchTeleCommands(equipmentIds, pagedSearchParams);
        },
        enabled: !!equipmentIds
    });
};

export const MenuCommunicationReactQuery = () => {
    return useQuery({
        queryKey: ['data'],
        queryFn: () => fetchPowerStationTree()
    })
}


